<template>
  <div
    v-if="showModalLoadingSpinner"
    class="modal-dialog modal-dialog-centered modal-xl"
    role="document"
    style="height: 90vh; width: 85vw; max-width: 90%"
  >
    <div
      class="modal-content"
      style="height: 100%; width: 100%; overflow-y: auto; text-align: left !important"
    >
      <div class="modal-body p-0">
        <div
          class="card card-plain"
          style="height: 100%"
        >
          <div
            class="card-body justify-content-left d-flex flex-column align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="spinner-border"
              style="width: 100px; height: 100px"
              role="status"
            ></div>
            <p class="mt-3">Loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else-if="baggingDiagramDataPerGun.length > 0"
    class="modal-dialog modal-dialog-centered modal-xl"
    role="document"
    style="height: 90vh; width: 85vw; max-width: 90%"
  >
    <div
      class="modal-content"
      style="height: 100%; width: 100%; overflow-y: auto; text-align: left !important"
    >
      <div class="modal-body p-0">
        <div class="card card-plain">
          <div class="card-body justify-content-left">
            <button
              ref="dismissButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                color: black;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 99999 !important;
                margin: 10px;
                padding: 5px;
              "
            >
              <font-awesome-icon :icon="['fas', 'xmark']" />
            </button>
            <h3 class="text-start mb-3">Bagging Details</h3>
            <div class="d-flex align-items-center justify-content-between mb-2 position-relative" style="min-height: 70px;">
              <nav
                aria-label="breadcrumb"
                style="width: 150px; position: absolute; left: 0; top: 50%; transform: translateY(-50%);"
              >
                <ol class="breadcrumb align-items-center mb-0">
                  <li class="breadcrumb-item text-bold text-md">{{ hopperName }}</li>
                </ol>
              </nav>
              <div
                class="d-flex align-self-center justify-content-between"
                style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); height: 100%; width: 25%; min-width: 250px;"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <button
                    class="btn btn-light shadow-none m-0"
                    data-toggle="button"
                    :disabled="currentIndex === 0"
                    style="height: 40px;"
                    @click="currentIndex = currentIndex - 1"
                  >
                    <i
                      class="fa fa-chevron-left"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div class="d-flex align-items-center justify-content-center m-1" style="width: 50%; overflow-x: auto;">
                  <span class="align-middle text-bold text-md">Gun {{ getGunName(currentIndex) }}</span>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <button
                    class="btn btn-light shadow-none m-0"
                    data-toggle="button"
                    :disabled="currentIndex === baggingDiagramDataPerGun.length - 1"
                    style="height: 40px;"
                    @click="currentIndex = currentIndex + 1"
                  >
                    <i
                      class="fa fa-chevron-right"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
              <div
                v-if="baggingCreationTimestamp"
                class="d-flex align-items-center justify-content-center"
                style="position: absolute; right: 0; top: 50%; transform: translateY(-50%);"
              >
                <span class="text-sm text-muted me-2 mb-2"> Created: </span>
                <h6 class="text-sm">{{ baggingCreationTimestamp }}</h6>
              </div>
            </div>
            <SteelCaseGunsEqualizationChart
              :datasets="[baggingDiagramDataPerGun[currentIndex].datapoints_logistic_fit]"
              :powder-output-measurements="baggingDiagramDataPerGun[currentIndex].datapoints_powder_output_measurements"
              :show-controls="false"
            />
            <div
              class="mt-3 mb-3"
              style="overflow-x: auto"
            >
              <div class="table-responsive">
                <table
                  class="table table-sm text-center"
                  style="border-width: 0 !important"
                >
                  <thead>
                    <tr>
                      <th style="width: 33.3%">Guns</th>
                      <th style="width: 33.3%">{{ isInFirstPage ? "Venturi Diameter" : "Setting " + currentPage }}</th>
                      <th style="width: 33.3%">{{ isInFirstPage ? "Empty Bag Weight" : "Weight " + currentPage }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(bagging_diagram_data, index) in baggingDiagramDataPerGun"
                      :key="index"
                    >
                      <td
                        class="align-middle"
                        style="width: 33.3%"
                      >
                        <button
                          class="btn btn-outline-secondary m-0 px-4 py-2"
                          style="min-width: 120px"
                          data-toggle="button"
                          @click="currentIndex = index"
                        >
                          Gun {{ bagging_diagram_data.gun_name }}
                        </button>
                      </td>
                      <td
                        class="align-middle"
                        style="width: 33.3%"
                      >
                        <p>
                          {{
                            isInFirstPage
                              ? bagging_diagram_data.venturi_diameter
                              : bagging_diagram_data.datapoints_powder_output_measurements[currentPage - 1].x
                          }}
                        </p>
                      </td>
                      <td
                        class="align-middle"
                        style="width: 33.3%"
                      >
                        <p>
                          {{
                            isInFirstPage
                              ? bagging_diagram_data.empty_bag_weight
                              : bagging_diagram_data.datapoints_powder_output_measurements[[currentPage - 1]].y
                          }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <soft-pagination
                class="justify-content-center mt-3 mb-3"
                color="secondary"
                aria-label="Experiment thickness measures input pages"
              >
                <SoftPaginationItem
                  prev
                  :disabled="currentPage === 0"
                  @click="goToPrevPage"
                />
                <SoftPaginationItem
                  label="0"
                  :active="currentPage === 0"
                  @click="goToPage(0)"
                />
                <SoftPaginationItem
                  label="1"
                  :active="currentPage === 1"
                  @click="goToPage(1)"
                />
                <SoftPaginationItem
                  label="2"
                  :active="currentPage === 2"
                  @click="goToPage(2)"
                />
                <SoftPaginationItem
                  label="3"
                  :active="currentPage === 3"
                  @click="goToPage(3)"
                />
                <SoftPaginationItem
                  next
                  :disabled="currentPage === 3"
                  @click="goToNextPage"
                />
              </soft-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="modal-dialog modal-dialog-centered modal-sm"
    role="document"
  >
    <div
      class="modal-content"
      style="text-align: left !important"
    >
      <div class="modal-body p-0">
        <div class="card card-plain">
          <div class="card-body justify-content-left">
            <button
              ref="dismissButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label=""
              style="
                color: black;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 99999 !important;
                margin: 10px;
                padding: 5px;
              "
            >
              <font-awesome-icon :icon="['fas', 'xmark']" />
            </button>
            <div
              class="swal2-icon swal2-error swal2-icon-show"
              style="display: flex"
            >
              <span class="swal2-x-mark">
                <span class="swal2-x-mark-line-left"></span>
                <span class="swal2-x-mark-line-right"></span>
              </span>
            </div>
            <h3 class="text-center">Error</h3>
            <p class="text-center">Failed to fetch detailed data for these guns.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import SteelCaseGunsEqualizationChart from "./SteelCaseGunsEqualizationChart.vue";

library.add(faXmark);

export default {
  name: "BaggingDetailModal",
  components: {
    SoftPagination,
    SoftPaginationItem,
    SteelCaseGunsEqualizationChart,
    FontAwesomeIcon,
  },
  props: {
    baggingDiagramDataPerGun: {
      type: Array,
      required: true,
    },
    showModalLoadingSpinner: {
      type: Boolean,
      required: true,
    },
    hopperName: {
      type: String,
      optional: true,
      default: null,
    },
    baggingCreationTimestamp: {
      type: String,
      optional: true,
      default: null,
    },
  },
  emits: ["close"],
  data() {
    return {
      currentIndex: 0,
      currentPage: 0,
      firstPage: 0,
      lastPage: 3,
    };
  },
  computed: {
    isInFirstPage() {
      return this.currentPage === this.firstPage;
    },
    isInLastPage() {
      return this.currentPage === this.lastPage;
    },
  },
  mounted() {
  },
  methods: {
    getGunName(current_index) {
      const current_gun_data = this.baggingDiagramDataPerGun[current_index];
      return current_gun_data ? current_gun_data.gun_name : null;
    },
    closeModal() {
      const dismissButton = this.$refs.dismissButton;
      if (dismissButton) {
        dismissButton.click();
      }
    },
    goToPrevPage() {
      if (this.currentPage > 0) {
        this.currentPage = this.currentPage - 1;
      }
    },
    goToNextPage() {
      if (this.currentPage < 3) {
        this.currentPage = this.currentPage + 1;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    },
  },
};
</script>
